import React, { Component } from 'react';
import { Row, Col } from "reactstrap";
import { inject, observer } from "mobx-react/index";
import CardDetalhe from "../../../comum/components/CardDetalhe";
import { formatarDataCustomHTML } from "../../../../utils/formatar"

@inject("store")
@observer
export default class DetalhesAgServicos extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Col xs={12} className="container-card-detalhe">
                <div className="pb-3 pt-3">
                    <h4>{this.props.titulo}</h4>
                    <Row className="m-0 no-gutters">
                        <Col sm={4}>
                            <CardDetalhe titulo={"Cliente"}
                                desc={[this.props.row.Cliente]}
                                pt="pt-2"
                                pb="pb-2"
                            />
                        </Col>
                        <Col sm={4}>
                            <CardDetalhe titulo={"Criado por"}
                                desc={[this.props.row.UsuIncl]}
                                titulo2={"Data e hora"}
                                desc2={this.props.row.DatIncl}
                                formatacao2={formatarDataCustomHTML}
                                pt="pt-2"
                                pb="pb-2"
                            />
                        </Col>
                        <Col sm={4}>
                            <CardDetalhe titulo={"Alterado por"}
                                desc={[this.props.row.UsuAlt]}
                                titulo2={"Data e hora"}
                                desc2={this.props.row.DatUsuAlt}
                                formatacao2={formatarDataCustomHTML}
                                pt="pt-2"
                                pb="pb-2"
                            />
                        </Col>
                    </Row>
                </div>
            </Col>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamentoservicos/visualizar/components/DetalhesAgServicos.js